import { useWatch } from 'react-hook-form/dist/index.ie11';
import { SSOIdentifierEnum } from 'src/types/Corp';
import { FeatureFlag } from 'src/types/FeatureFlag';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';

type UseSSOWrapperReturn = {
  ssoEnabled: boolean;
  showUniqueIdentifier: boolean;
  ssoDisabled: boolean;
  passwordRestrictDisabled: boolean;
  showSsoOnNativeOption: boolean;
  showSsoRedirectUrl: boolean;
};

export function useSSOWrapper(): UseSSOWrapperReturn {
  const { corpData } = useCorporateFormContext();

  const { value: showSsoOnNativeOption } = useFeatureFlag(
    FeatureFlag.SHOW_SSO_ON_NATIVE_OPTION
  );

  const ssoDisabled =
    corpData?.ssoEnabled === true && corpData?.passwordRestricted;
  const passwordRestrictDisabled =
    corpData?.ssoEnabled === true &&
    corpData?.passwordRestrictedToggleLock === true;

  const { ssoEnabled, ssoIdentifier, ssoRedirectEnabled } = useWatch({
    name: ['ssoEnabled', 'ssoIdentifier', 'ssoRedirectEnabled'],
  });

  return {
    ssoEnabled,
    ssoDisabled,
    passwordRestrictDisabled,
    showUniqueIdentifier: ssoIdentifier === SSOIdentifierEnum.OTHER,
    showSsoOnNativeOption,
    showSsoRedirectUrl:
      showSsoOnNativeOption && ssoEnabled && ssoRedirectEnabled,
  };
}
